module.exports = __webpack_public_path__ + "img/shipo-sales-plan-icon-pdf.42cb8ecc.svg";